import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { FaBreadSlice, FaHeart, FaUsers } from "react-icons/fa";
import aboutImage from "../assets/image/SHMUEL_ABOUT.jpg";
import "./About.css";
import PrimaryButton from "components/PrimaryButton";

const About: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="about-page-container" data-language={i18n.language}>
      <section className="about-main-section">
        <div className="about-main-container">
          <div className="about-content">
            <h1 className="about-main-title">{t("aboutMainTitle")}</h1>
            <p className="about-description-bold">
              {t("aboutDescriptionBold")}
            </p>
            <p className="about-description">{t("aboutDescriptionRegular")}</p>

            <PrimaryButton onClick={() => navigate("/about-detail")}>
              {t("aboutButton")}
            </PrimaryButton>
          </div>
          <div className="about-image">
            <img src={aboutImage} alt={t("aboutImageAlt")} />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
